import React from 'react'
import bulb from "../../../images/students/bulb.webp"
import cheer from "../../../images/students/cheer.webp"
import growth from "../../../images/students/growth.webp"
import { LuCircleCheckBig } from 'react-icons/lu'

export default function WhatBuilds() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] relative z-0 w-full overflow-hidden text-center bg-[#F9FAFB]'>
            <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>What Surge Student Builds</h3>
            <p className='mt-[5px] md:mt-[10px] text-[#7D7F81] font-normal text-[14px] md:text-[25px]'>The 3C Promise</p>
            <div className='mt-[18px] grid md:grid-cols-2 lg:grid-cols-3 gap-[20px] md:w-11/12 mx-auto text-start'>
                <div className='w-full p-[20px] xl:p-[38px] rounded-[14px] md:rounded-[28px] bg-[#FFFFFF]' style={{ boxShadow: "0px 0px 15px -3px #0000001A" }}>
                    <img src={bulb} alt='bulb' loading='lazy' className=' size-[130px] md:size-[190px] object-cover' />
                    <div className='mt-[12px] md:mt-[27px]'>
                        <p className='text-[#000] font-semibold text-[22px] md:text-[32px]'>Clarity</p>
                        <div className='mt-[12px] md:mt-[27px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                            <div className='flex gap-[8px] md:gap-[12px] items-center'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Who you are</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Where you belong</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>What path fits your identity</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>What skills match your strengths</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[46px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>What future suits you</p>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='w-full p-[20px] xl:p-[38px] rounded-[14px] md:rounded-[28px] bg-[#FFFFFF]' style={{ boxShadow: "0px 0px 15px -3px #0000001A" }}>
                    <img src={cheer} alt='cheer' loading='lazy' className=' size-[130px] md:size-[190px] object-cover' />
                    <div className='mt-[12px] md:mt-[27px]'>
                        <p className='text-[#000] font-semibold text-[22px] md:text-[32px]'>Confidence</p>
                        <div className='mt-[12px] md:mt-[27px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                            <div className='flex gap-[8px] md:gap-[12px] items-center'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Mindset</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Communication</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Presence</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Identity building</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Consistency</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Self-belief</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-full p-[20px] xl:p-[38px] rounded-[14px] md:rounded-[28px] bg-[#FFFFFF] md:col-span-2 lg:col-span-1' style={{ boxShadow: "0px 0px 15px -3px #0000001A" }}>
                    <img src={growth} alt='growth' loading='lazy' className=' size-[130px] md:size-[190px] object-cover' />
                    <div className='mt-[12px] md:mt-[27px]'>
                        <p className='text-[#000] font-semibold text-[22px] md:text-[32px]'>Capability</p>
                        <div className='mt-[12px] md:mt-[27px] text-[#101828] font-medium text-[14px] md:text-[20px]'>
                            <div className='flex gap-[8px] md:gap-[12px] items-center'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Skill readiness</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Real-world thinking</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Decision-making</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Problem-solving</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Professional behavior</p>
                            </div>
                            <div className='flex gap-[8px] md:gap-[12px] items-center mt-[20px] md:mt-[36px]'>
                                <LuCircleCheckBig className='text-[14px] md:text-[22px] text-[#00A63E] flex-shrink-0' />
                                <p>Ownership</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-[19px] md:mt-[38px]'>
                <h5 className='text-[#101828] text-[16px] md:text-[34px] font-semibold'>No job promises <span className="mx-1 md:mx-3">•</span>  No shortcuts <span className="mx-1 md:mx-3">•</span> No hype</h5>
                <p className='mt-[6px] md:mt-[10px] text-[#4A5565] text-[12px] md:text-[25px] font-normal'>We build the person — so the person builds their future.</p>
            </div>
        </div>
    )
}
